import React, { Component, Fragment } from 'react';
import {connect} from "react-redux";
import {IRootState} from "../../../store";
import DispatchProps from "../../../utils/DispatchProps";
import PageTitle from "../../PageTitle";
import ApiService from "../../ApiService";
import H from "history";
import TenantSummary from "../../../models/tenants/TenantSummary";
import {UserAccessLevel} from "../../../models/UserAccessRecord";
import TenantList from "../../tenants/TenantList";
import School from "../../../models/School";
import SchoolList from "../../SchoolList";
import {Link} from "react-router-dom";
import {CommandBarButton} from "office-ui-fabric-react";

interface TenantPageProps {
    tenantId: string;
    
    apiService: ApiService;
    history: H.History;
    usersCdbAccessLevel?: UserAccessLevel;
}

interface TenantPageState {
    tenant?: TenantSummary | null;
    schools?: School[];
}

class TenantPage extends Component<TenantPageProps & DispatchProps ,TenantPageState> {
    static displayName = TenantPage.name;
    
    constructor(props: TenantPageProps & DispatchProps) {
        super(props);

        this.state = {
            tenant: undefined,
            schools: undefined
        }
    }

    async componentDidMount() {
        
        const tenant = await this.props.apiService.getTenantAdmin(this.props.tenantId);
        const schools = await this.props.apiService.getSchoolsForTenantAdmin(this.props.tenantId);
        
        this.setState({
            tenant,
            schools
        });
    }

    async componentDidUpdate(prevProps: Readonly<TenantPageProps & DispatchProps>, prevState: TenantPageState): Promise<void> {
    }
    render () {
        
        const tenantFriendlyName = this.state.tenant?.tenantName ?? this.props.tenantId;
        
        return (
            <Fragment>
                <PageTitle title={tenantFriendlyName}/>

                
                <TenantList title={tenantFriendlyName} items={this.state.tenant ? [this.state.tenant] : undefined} enableRowLinks={false}>
                    <Link to={`/cdb-admin/tenants/${this.props.tenantId}/support-mfa`}>
                        <CommandBarButton
                            iconProps={{ iconName: "AuthenticatorApp" }}
                            text="Support MFA"
                        />
                    </Link>
                    <Link to={`/cdb-admin/tenants/${this.props.tenantId}/app-permissions`}>
                        <CommandBarButton
                            iconProps={{ iconName: "Permissions" }}
                            text="App Permissions"
                        />
                    </Link>
                    <Link to={`/manage-tenant/${this.props.tenantId}/tenant-manager`}>
                        <CommandBarButton
                            iconProps={{ iconName: "Signin" }}
                            text="Tenant Managers"
                        />
                    </Link>
                    <Link to={`/manage-tenant/${this.props.tenantId}/assignment-analytics`}>
                        <CommandBarButton
                            iconProps={{ iconName: "Chart" }}
                            text="Tenant Assignment Analytics"
                        />
                    </Link>
                </TenantList>
                
                <SchoolList title={`Schools in ${tenantFriendlyName}`} enableRowLinks={true} schools={this.state.schools!} loading={this.state.schools == undefined}/>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: {match: any, history: H.History}): TenantPageProps => {
        return {
            tenantId: ownProps.match.params.tenantId,
            history: ownProps.history,
            apiService: state.auth.apiService,
            usersCdbAccessLevel: state.auth.usersCdbAccessLevel
        };
    }
)(TenantPage)